<div #faqPage data-section-id="faq-page-section" data-section-name="FAQ Page">
  <app-faq-hero></app-faq-hero>
  <app-faq-accordion></app-faq-accordion>

  <app-cta-banner></app-cta-banner>
</div>

<!-- Botones flotantes reutilizables -->
<app-floating-buttons></app-floating-buttons>
